import Vue from 'vue'
import App from './App.vue'
import router from './router'
import wayCode from './utils/wayCode';
import cacheTokenUtil from './utils/cacheToken'
import config from './config'
import 'amfe-flexible'
Vue.config.productionTip = false

/**
 * 路由守卫
 *
 * @author caixinfeng
 * @site https://pay.poa.ai
 * @date 2021/5/8 07:18
 */
router.beforeEach((to, from, next) => {

    console.log("进入路由守卫", from, to)

    // from: 当前导航正要离开的路由
    // to: 即将要进入的目标路由对象

    // 如果在免登录页面则直接放行
    if (config.passGuardRouteList.includes(to.name)) {
      // 在免登录名单，直接进入
      next()
      return false
    }

    //获取不到参数
    let token = to.params[config.urlTokenName] || to.query[config.urlTokenName];
    if(token){  //放置token信息
        config.cacheToken = token;
        cacheTokenUtil.setCacheToken(token)
    }else{
        config.cacheToken = cacheTokenUtil.getCacheToken();
    }

    let openid = to.params[config.wechatAuth] || to.query[config.wechatAuth];
    if(openid){  //放置openid信息
        config.openid = openid;
    }

    console.log(wayCode.getPayWay());
    if(!config.cacheToken) {
        next({ name: config.errorPageRouteName, params: { errInfo: "请通过二维码进入支付页面！" } })
        return false;
    }

    //获取不到支付类型, 需要跳转到错误页面
    if(!wayCode.getPayWay()) {
        next({name: config.errorPageRouteName, params: {errInfo: "请用微信或Alipay+钱包内扫码进入！"}})
        return false;
    }

    next()
})


Vue.prototype.$config = config;

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
